import {Component, Injector, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {ClaimService} from "../../../../services/claim.service";
import {Claim} from "../../../../model/claim.model";
import {ClaimsBaseComponent} from "../../../claim-base.component";
import {DatePipe} from "@angular/common";
import {VisitedDoctor} from "../../../../model/travel/visted-a-doctor.model";
import { DocumentDetails } from "../../../../model/document-details.model";
import { DocumentField } from "../../../../model/document-field";
import { ClaimTypes } from "../../../../model/claim-type.model";
import { DocumentHelperService } from "../../../../services/document-helper.service";

@Component({
    selector: 'app-summary-visited-a-doctor',
    templateUrl: './summary-visited-a-doctor.component.html',
    styleUrls: ['./summary-visited-a-doctor.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SummaryVisitedADoctorComponent extends ClaimsBaseComponent implements OnInit {

    claim: Claim;
    visitedDoctor: VisitedDoctor;
    listOfDocuments: DocumentField[] = [];
    listOfOtherDocuments: DocumentField[] = [];

    constructor(private claimService: ClaimService,
        private documentHelperService: DocumentHelperService,
                private injector : Injector) {

        super(injector);
        this.claim = this.claimService.getClaim();
        this.visitedDoctor = this.claim.getClaimTravel().getVisitedDoctor();
        this.listOfDocuments = this.documentHelperService.getListOfUploadedDocuments(this.claimService.claim.getDocumentForm().documents,
        this.documentHelperService.getDocumentFormBuilder(ClaimTypes[ClaimTypes.CLAIM_TYPE_MED_VISIT]).getRequiredDocuments(),
        ClaimTypes[ClaimTypes.CLAIM_TYPE_MED_VISIT]);
        this.listOfOtherDocuments = this.documentHelperService.getListOfOtherUploadedDocuments(this.claimService.claim.getDocumentForm().documents,
        this.documentHelperService.getDocumentFormBuilder(ClaimTypes[ClaimTypes.CLAIM_TYPE_MED_VISIT]).getRequiredDocuments(),
        ClaimTypes[ClaimTypes.CLAIM_TYPE_MED_VISIT]);
    }

    ngOnInit() {

    }

    returnYesOrNo(value: boolean) {
        if (true === value) {
            return this.translate.instant("claimSection.generalLabels.radioButtonLabels.yes");
        } else {
            if (false === value) {
                return this.translate.instant("claimSection.generalLabels.radioButtonLabels.no");
            }
        }

        return '';
    }

    returnYesOrNoOtherContext(value: boolean) {
        if (true === value) {
            return this.translate.instant("claimSection.generalLabels.generalButtonLabels.yes");
        } else {
            if (false === value) {
                return this.translate.instant("claimSection.generalLabels.generalButtonLabels.no");
            }
        }

        return '';
    }

    getDate(dt: Date) {
        if (dt && dt != null) {
            return new DatePipe('en-US').transform(dt, "dd/MM/yyyy");
        }
        else {
            return "";
        }
    }
    
}
